import type { CityConfig } from "../city-template/types";

export const fishkillConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fishkill",
  state: "New York",
  stateAbbr: "NY",
  slug: "fishkill",
  route: "/fishkill",
  title: "Emergency Passport Fishkill, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fishkill, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Fishkill I-84 corridor travelers, Dutchess County families, SWF Dublin route passengers, and Hudson Valley commuters.",
  h1: "Emergency & Expedited Passport Services in Fishkill, NY",
  heroSubtitle: "Fishkill sits at the crossroads of the Hudson Valley — the I-84 corridor connecting New England to Pennsylvania, Stewart International Airport just 15 miles away, and Metro-North commuters heading to NYC daily. Whether you booked the SWF-to-Dublin flight without checking your passport, need a renewal before a business trip to Europe, or are a Dutchess County family preparing for a first international vacation — Fast Passport Center delivers. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20the%20Fishkill%20New%20York%20area%20along%20the%20Route%209%20and%20I-84%20corridor%20in%20Dutchess%20County%2C%20Hudson%20Valley%20landscape%20with%20rolling%20green%20hills%20and%20modern%20suburban%20development%2C%20warm%20golden%20afternoon%20light%20illuminating%20tree-lined%20roads%20and%20shopping%20districts%2C%20the%20Hudson%20Highlands%20visible%20in%20the%20distance%2C%20editorial%20travel%20photography%20style%2C%20clean%20composition%20with%20deep%20depth%20of%20field%2C%20no%20text%20overlay%2C%20vibrant%20but%20natural%20color%20palette&width=1600&height=700&seq=fishkill-hero-2026-v2&orientation=landscape",
  heroImageAlt: "Fishkill New York I-84 corridor with Hudson Valley landscape and Hudson Highlands in distance",
  geoPosition: "41.5356;-73.8990",
  geoPlacename: "Fishkill, New York",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "Located in Manhattan — approximately 65 miles from Fishkill, appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Fishkill", zips: "12524" },
    { name: "Beacon", zips: "12508" },
    { name: "Poughkeepsie", zips: "12601–12604" },
    { name: "Newburgh", zips: "12550–12555" },
    { name: "Wappingers Falls", zips: "12590" },
    { name: "Hopewell Junction", zips: "12533" },
    { name: "Highland", zips: "12528" },
    { name: "New Paltz", zips: "12561" },
    { name: "Kingston", zips: "12401, 12402" },
    { name: "Middletown", zips: "10940, 10941" },
    { name: "Cold Spring", zips: "10516" },
    { name: "Cornwall", zips: "12518, 12520" },
    { name: "New York City", zips: "10001–10282" },
    { name: "White Plains", zips: "10601–10607" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour SWF & JFK Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Fishkill-area travelers with immediate departures from SWF, JFK, or LGA." },
    { icon: "ri-flight-takeoff-line", title: "SWF Dublin Route Expertise", desc: "Stewart International's direct Dublin flight is the closest international route to Fishkill. We know the unique passport trap: book the convenient local flight, discover the expired passport, one daily departure." },
    { icon: "ri-train-line", title: "Metro-North Commuter Ready", desc: "Fishkill is minutes from Beacon Station on the Hudson Line. Commuters discover expired passports Friday evening for Saturday JFK departures — we handle the compressed timeline." },
    { icon: "ri-building-2-line", title: "Dutchess County Growth Corridor", desc: "Fastest-growing county in the Hudson Valley with new residents, first-time passport applicants, and families discovering international travel. We guide everyone through." },
  ],
  internalLinks: [
    { name: "Fast passport services in Poughkeepsie, NY", route: "/poughkeepsie" },
    { name: "Expedited passport in Beacon, NY", route: "/beacon" },
    { name: "Quick passport services in Newburgh, NY", route: "/newburgh" },
    { name: "Urgent passport services in Middletown, NY", route: "/middletown-ny" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Fishkill via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 65 miles to Manhattan. Fishkill residents can ship from any UPS Store, FedEx Office, or post office location across Dutchess County.",
  fpcOfficeDistance: "Serving Fishkill, Beacon, Wappingers Falls, Hopewell Junction, Cold Spring, and all I-84 corridor and Dutchess County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Fishkill and the greater I-84 corridor. From the Route 9 commercial district to the Beacon train station commuters, from Wappingers Falls families to Hopewell Junction professionals — we serve all of southern Dutchess County. Our courier service eliminates the need to drive 65 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Fishkill and all Dutchess County communities including Beacon, Wappingers Falls, Hopewell Junction, Poughkeepsie, and Cold Spring. We also serve travelers departing from Stewart International Airport (SWF), JFK, and LaGuardia who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Fishkill as simple as possible — with the efficiency and reliability Dutchess County commuters and Hudson Valley families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Fishkill travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Fishkill travelers encounter unique passport issues — from the SWF Dublin route trap to Metro-North Friday commuter panics. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Fishkill travelers — from I-84 commuters to Dutchess County families to Beacon artists — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Fishkill, NY? Here are the most common ones we hear from Dutchess County travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a SWF Dublin flight, an emergency passport for a last-minute JFK departure, or a first-time passport for a Dutchess County family — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SWF Dublin flight in two days? JFK departure this weekend? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Fishkill-area travelers who discover expired passports at the worst possible moment.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Fishkill residents renew fast — no agency visit required for most renewals. Perfect for Dutchess County commuters, Beacon artists, and I-84 corridor professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Fishkill residents through every step — from the Route 9 corridor to Beacon to Hopewell Junction — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your SWF connection or JFK international departure is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Dutchess County family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Hudson Valley professionals after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Fishkill professionals and Dutchess County executives who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Dutchess County travelers through the process — especially those whose passports have suffered water damage from Hudson River recreation.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Fishkill NY", description: "Urgent passport processing for Fishkill New York travelers with immediate departure needs from Stewart International or JFK." },
    { name: "Expedited Passport Renewal Fishkill NY", description: "Fast passport renewal for Fishkill New York residents with a previously-issued passport." },
    { name: "First-Time Passport Fishkill NY", description: "New passport application services for Fishkill New York residents applying for their first passport." },
    { name: "Child Passport Fishkill NY", description: "Minor passport services for Fishkill New York families with children under 16." },
    { name: "Name Change Passport Fishkill NY", description: "Passport name correction after marriage, divorce, or legal name changes for Fishkill residents." },
    { name: "Second Passport Fishkill NY", description: "Second passport services for Fishkill professionals and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Michael D.",
      location: "Fishkill, NY",
      rating: 5,
      text: "Had a business trip to Germany in 5 days. Fast Passport Center got my expedited passport processed in 3 days. I work in the Route 9 corridor and being able to handle everything remotely without driving to Manhattan was a game-changer.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Patricia W.",
      location: "Hopewell Junction, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. The whole process was smooth and stress-free — way better than the post office experience I had last time.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas H.",
      location: "Wappingers Falls, NY",
      rating: 5,
      text: "First-time passport for my family cruise out of New York. The agent helped us with the acceptance clerk appointment at the Fishkill post office and reviewed all our documents. Processed in 5 days. Amazing service for a busy family.",
      service: "New Passport",
    },
    {
      name: "Jennifer S.",
      location: "Beacon, NY",
      rating: 5,
      text: "I commute from Beacon to NYC daily and booked a last-minute trip to Paris. Discovered my passport expired on a Thursday evening with a Saturday JFK departure. Fast Passport Center handled it in under 48 hours. Unbelievable.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "fishkill-1",
      name: "Fishkill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1068 Main Street",
      city: "Fishkill",
      state: "NY",
      zip: "12524",
      phone: "(845) 896-9600",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Fishkill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Fishkill and southern Dutchess County. First-time applicants must appear in person. Saturday hours available — book early during peak summer travel season. Photo services on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "fishkill-2",
      name: "Beacon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "369 Main Street",
      city: "Beacon",
      state: "NY",
      zip: "12508",
      phone: "(845) 831-4200",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Beacon, approximately 5 miles from Fishkill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Beacon residents and Metro-North commuters. Walking distance from Beacon Station on the Hudson Line. Saturday appointments available — popular with weekend commuters.",
      icon: "ri-mail-line",
    },
    {
      id: "fishkill-3",
      name: "Wappingers Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "38 Market Street",
      city: "Wappingers Falls",
      state: "NY",
      zip: "12590",
      phone: "(845) 297-4290",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Wappingers Falls, approximately 8 miles from Fishkill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Wappingers Falls and central Dutchess County. Passport photos available. Smaller facility — call ahead to confirm clerk availability during peak season.",
      icon: "ri-mail-line",
    },
    {
      id: "fishkill-4",
      name: "Dutchess County Clerk — Poughkeepsie",
      type: "County Clerk Passport Acceptance",
      address: "22 Market Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "(845) 486-2133",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Poughkeepsie, approximately 12 miles from Fishkill",
      website: "https://www.dutchessny.gov/Departments/County-Clerk/Passports.htm",
      websiteLabel: "Dutchess County Clerk",
      notes: "County clerk passport acceptance services at the Dutchess County office. No photo services on-site — bring your own 2x2 photos. Walk-ins accepted but appointments recommended.",
      icon: "ri-government-line",
    },
    {
      id: "fishkill-5",
      name: "Newburgh Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 Liberty Street",
      city: "Newburgh",
      state: "NY",
      zip: "12550",
      phone: "(845) 562-0150",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Newburgh, approximately 15 miles from Fishkill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Larger facility across the Hudson River in Orange County. Good option if Fishkill and Beacon appointments are booked during peak season. Full photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fishkill-6",
      name: "Cold Spring Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "51 Chestnut Street",
      city: "Cold Spring",
      state: "NY",
      zip: "10516",
      phone: "(845) 265-3823",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Cold Spring, approximately 12 miles from Fishkill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Small Putnam County facility convenient for southern Dutchess County residents. Scenic Hudson River village location. Limited hours — call ahead to confirm clerk availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 65 miles to Manhattan", fpc: "Most I-84 corridor travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Fishkill-Specific Guidance", agency: "Generic — no SWF airport, Metro-North commuter, or I-84 corridor expertise", fpc: "Full SWF/Metro-North/I-84 corridor/Dutchess County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "The SWF Dublin Route Trap",
      description: "Stewart International's direct Dublin flight is the closest international route to Fishkill. Travelers book the convenient local flight, discover their passport expired, then realize there is only one daily departure. We catch this before it becomes a crisis.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Metro-North Friday Afternoon Passport Panic",
      description: "Fishkill commuters frequently discover expired passports Friday evening — after the work week — with Saturday or Sunday JFK departures. This compressed 24–48 hour window requires emergency processing. We understand this Hudson Valley commuter pattern.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Fishkill applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks in a region where JFK departures happen on short notice.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Dutchess County travelers booking to Ireland, the UK, or European destinations from SWF or JFK often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Fishkill pharmacies and big-box stores produce photos that fail State Department standards. We catch this in review before it causes a rejection — especially common for families getting photos at CVS or Walgreens without checking specs.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or Metro-North commute." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your SWF or JFK travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Fishkill clients ship from the Fishkill Post Office on Main Street or the UPS Store on Route 9 — no Manhattan visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 65 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty for your travel from Fishkill." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Fishkill?", a: "We offer Fishkill-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Fishkill office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Fishkill, Beacon, or Wappingers Falls post office), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Fishkill address." },
    { q: "Where can I get a passport acceptance in Fishkill?", a: "Fishkill has acceptance facilities at the Fishkill Post Office (1068 Main Street), Beacon Post Office (369 Main Street), and Wappingers Falls Post Office (38 Market Street). The Dutchess County Clerk in Poughkeepsie also offers passport acceptance services." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, 65 miles from Fishkill) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "What is the best price for expedited passport service in Fishkill?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can I fly from Stewart International Airport to Dublin without a valid passport?", a: "No. Even though SWF is a smaller regional airport, the Dublin flight is an international departure requiring a valid passport. Many Fishkill travelers book the convenient SWF-to-Dublin route months in advance and only check their passport weeks before departure — often discovering it is expired. We handle these compressed timelines regularly." },
    { q: "Can I get a passport photo in Fishkill?", a: "Yes — the Fishkill Post Office offers photo services on-site. CVS, Walgreens, and the UPS Store on Route 9 also offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression. We review photos before submission to ensure compliance." },
    { q: "How do I check my Fishkill passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Fishkill to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help if I discover an expired passport the day before a JFK flight?", a: "Yes — this is one of the most common scenarios for Fishkill commuters who use Metro-North. We offer 24-hour emergency processing and regularly handle Friday-afternoon-to-Saturday-departure timelines for Hudson Valley travelers." },
    { q: "What airports do Fishkill travelers typically use?", a: "Fishkill residents use Stewart International (15 miles, Dublin direct), JFK (65 miles, global international flights), LaGuardia (60 miles, domestic connections to international hubs), and occasionally Albany (80 miles). Each airport has different passport check requirements at check-in — we advise based on your specific itinerary." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Fishkill Residents",
    intro: "Fishkill's position at the I-84 crossroads — 15 miles from Stewart International, 65 miles from JFK, and minutes from the Beacon Metro-North station — creates uniquely compressed passport timelines. Here's what Dutchess County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF — Stewart International Airport",
        subtitle: "15 miles from Fishkill, direct Dublin flights",
        description: "Stewart International is Fishkill's closest airport and the Hudson Valley's primary aviation hub. The SWF-to-Dublin direct route on Norse Atlantic Airways is the only direct international flight from the Hudson Valley — and it creates a unique passport trap. Travelers book the convenient local flight, never think about their passport, and discover the problem weeks or days before departure. With only one daily Dublin departure, there is no Plan B.",
        tip: "If you book the SWF Dublin flight, check your passport validity the same day you book. The one daily departure means no flexibility — you either have a valid passport or you do not fly.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "JFK — John F. Kennedy International Airport",
        subtitle: "65 miles, global international hub",
        description: "JFK is the primary international gateway for Fishkill travelers heading to Europe, Asia, the Middle East, and beyond. The 65-mile journey typically takes 90 minutes to 2 hours depending on traffic. Many Fishkill residents combine the drive with Metro-North to Grand Central and the LIRR to Jamaica Station. The multi-leg journey means passport issues discovered at JFK are catastrophic — you are hours from home.",
        tip: "For JFK departures, check passport validity at least 3 weeks before travel. If you discover an issue, our 24-hour courier service can process faster than driving to Manhattan for an agency appointment.",
      },
      {
        icon: "ri-train-line",
        title: "Metro-North Hudson Line & Commuter Culture",
        subtitle: "Beacon Station, 5 miles from Fishkill",
        description: "Fishkill is minutes from Beacon Station on Metro-North's Hudson Line, connecting southern Dutchess County to Grand Central Terminal in about 80 minutes. This commuter culture creates a specific passport urgency pattern: professionals discover expired passports on Thursday or Friday evening, with international departures from JFK or Newark scheduled for Saturday or Sunday. The 48-hour weekend turnaround window is the tightest in the Hudson Valley.",
        tip: "Metro-North commuters should keep a digital copy of their passport bio page on their phone. If you discover an issue during your commute home Friday evening, you can start the process immediately rather than waiting until you get home.",
      },
      {
        icon: "ri-building-2-line",
        title: "Dutchess County Growth & First-Time Applicants",
        subtitle: "Fastest-growing Hudson Valley county",
        description: "Dutchess County is experiencing significant population growth as remote workers and families relocate from New York City to the Hudson Valley. This influx of new residents — many of whom have never held passports — creates a steady stream of first-time applicants. The gap between moving to Fishkill and booking a first international vacation is often just a few months, requiring expedited processing for DS-11 first-time applications that require an in-person acceptance clerk visit.",
        tip: "New Dutchess County residents should apply for a passport as soon as they establish residency — not when they book a trip. First-time applications require an in-person acceptance clerk visit and take longer than renewals.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Fishkill & the I-84 Crossroads Reality",
      description: "Fishkill sits at the intersection of I-84 (east-west between Pennsylvania and New England) and the Route 9/I-87 corridor (north-south between NYC and Albany). This crossroads position means Fishkill travelers access four international airports (SWF, JFK, LGA, EWR) and two domestic hubs (ALB, HPN) — creating more airport options but also more complexity when coordinating passport timelines with specific airport requirements.",
    },
  },
  destinations: {
    title: "Where Fishkill Travelers Go — And Why Passports Get Urgent",
    intro: "The I-84 corridor's connectivity to SWF, JFK, and Metro-North creates diverse international travel patterns. Here are the most common destinations and urgency patterns for Fishkill and Dutchess County travelers.",
    stats: [
      { stat: "30%", label: "of Fishkill expedited requests come from Metro-North commuters with 48-hour weekend turnaround" },
      { stat: "15 Miles", label: "from Fishkill to Stewart International Airport (SWF) with direct Dublin flights" },
      { stat: "May–Aug", label: "peak season when summer travel, family vacations, and SWF Dublin bookings converge" },
      { stat: "36 Hours", label: "shortest turnaround we have accommodated for a Beacon commuter departing JFK on a Saturday" },
    ],
    destinations: [
      { name: "Ireland", context: "SWF direct Dublin flights, Irish heritage tourism, family reunions, vacation packages", urgency: "SWF Dublin route bookings 2–4 months out — passport check often delayed until weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "JFK direct flights to Rome and Milan, heritage travel, summer vacations, Hudson Valley wine enthusiasts exploring Tuscany", urgency: "Summer vacation bookings peak January through April with passport validity often overlooked", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "JFK-London direct flights, business travel, heritage tourism, Westchester/Dutchess professional connections", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates in London or Edinburgh", icon: "ri-map-pin-2-line" },
      { name: "France", context: "JFK-Paris direct flights, Hudson Valley arts and culture travelers, culinary tourism, family heritage", urgency: "Paris travel often planned well in advance but passports checked late — especially for extended family groups", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "JFK and LGA departures, winter escape vacations, all-inclusive resort bookings, spring break family travel", urgency: "Last-minute winter deals booked December through March with 2–3 week lead time", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Cross-border trips to Montreal and Quebec, Niagara Falls family vacations, Toronto business travel", urgency: "Cross-border trips often planned 1–2 weeks out — passport card popular for land border crossings", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley and New York State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Poughkeepsie", route: "/poughkeepsie" },
      { name: "Beacon", route: "/beacon" },
      { name: "Newburgh", route: "/newburgh" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Fishkill", address: "1076 Main Street, Fishkill, NY 12524", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Beacon", address: "363 Main Street, Beacon, NY 12508", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "The UPS Store — Fishkill", address: "982 Main Street, Fishkill, NY 12524", hours: "Mon–Fri 9 AM – 7 PM, Sat 10 AM – 4 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Fishkill Post Office", address: "1068 Main Street, Fishkill, NY 12524", hours: "Mon–Fri 8:30 AM – 5 PM, Sat 9 AM – 12 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "FedEx Office — Poughkeepsie", address: "2585 South Road, Poughkeepsie, NY 12601", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 10 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart Supercenter — Fishkill", address: "18 Westage Drive, Fishkill, NY 12524", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Wappingers Falls", address: "1488 Route 9, Wappingers Falls, NY 12590", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/photo" },
    { name: "Rite Aid — Hopewell Junction", address: "2537 Route 52, Hopewell Junction, NY 12533", hours: "Call for hours", website: "https://www.riteaid.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Newburgh",
      address: "50 Liberty Street, Newburgh, NY 12550",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Newburgh DMV office for license renewals and REAL ID applications. Serves Fishkill, Beacon, and all Dutchess County communities.",
      featured: true,
    },
    {
      name: "NYS DMV — Poughkeepsie",
      address: "22a Ulster Avenue, Poughkeepsie, NY 12601",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Poughkeepsie DMV office serving north Dutchess County and Fishkill residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "Approximately 15 miles from Fishkill",
      address: "1 1st Street, New Windsor, NY 12553",
      note: "Regional airport with direct flights to Dublin, Orlando, and major U.S. hubs. Primary airport for Fishkill and Dutchess County travelers. The SWF Dublin route is the closest international flight option.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport Website",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "Approximately 65 miles from Fishkill",
      address: "Queens, NY 11430",
      note: "NYC's primary international airport with direct flights worldwide. Many Fishkill travelers use JFK for long-haul international travel to Europe, Asia, and beyond.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records. Online, mail, or in-person options for Dutchess County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS Department of Health Vital Records. Required for estate and legal matters in Dutchess County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Dutchess County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.dutchessny.gov/Departments/County-Clerk/County-Clerk.htm",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Dutchess County Clerk. Required for name change passport corrections.",
      url: "https://www.dutchessny.gov/Departments/County-Clerk/County-Clerk.htm",
    },
  ],
};

export default fishkillConfig;